module.exports = __webpack_public_path__ + "img/List-Normal.bf997523.webp";